import { useState } from 'react';
import { motion } from 'motion/react';
import { btnVariants, textVariants, iconVariants, transition } from './variants';
import styles from './LayoutBtns.module.css';

export default function LayoutBtns(props) {

    const { layout, setLayout } = props;
    const [ hover, setHover ] = useState('');

    return (
        <div className={styles.container}>
            <motion.button 
                className={styles.btn} 
                onClick={() => setLayout('grid')} 
                transition={transition}
                variants={btnVariants}
                initial='initial'
                animate={layout === 'grid' ? 'animate' : 'initial'}
                onMouseEnter={() => setHover('grid')}
                onMouseLeave={() => setHover('')}
            >
                <motion.div 
                    id='grid-text' 
                    className={styles.text} 
                    transition={transition}
                    variants={textVariants}
                    initial='initial'
                    animate={hover === 'grid' ? 'animate' : 'initial'}
                >
                    Grid
                </motion.div>
                <motion.i 
                    id='grid-icon' 
                    className='fas fa-grid' 
                    transition={transition}
                    variants={iconVariants}
                    initial='initial'
                    animate={hover === 'grid' ? 'animate' : 'initial'}
                />
            </motion.button>
            <motion.button 
                className={styles.btn} 
                onClick={() => setLayout('list')}
                transition={transition}
                variants={btnVariants}
                initial='initial'
                animate={layout === 'list' ? 'animate' : 'initial'}
                onMouseEnter={() => setHover('list')}
                onMouseLeave={() => setHover('')}
            >
                <motion.div 
                    id='list-text' 
                    className={styles.text} 
                    transition={transition}
                    variants={textVariants}
                    initial='initial'
                    animate={hover === 'list' ? 'animate' : 'initial'}
                >
                    List
                </motion.div>
                <motion.i 
                    id='list-icon' 
                    className='fas fa-list' 
                    transition={transition}
                    variants={iconVariants}
                    initial='initial'
                    animate={hover === 'list' ? 'animate' : 'initial'}
                />   
            </motion.button>
        </div>
    );
};